export const UPDATE_WARNINGS = 'UPDATE_WARNINGS';

export const updateWarnings = data => ({
  type: UPDATE_WARNINGS,
  data,
});
